import Checkbox from "@mostrans/web-components/components/base/Checkbox";
import { Accordion, AccordionDetails, AccordionSummary, FormControlLabel } from "@mui/material";
import React, { useState } from "react";

const listLevel = ["Entry Level", "Middle Level", "Senior Level"];

const FilterLevel = (props) => {
  const { classes, handleChange, filter } = props;
  const [active, setActive] = useState();

  console.log("filter", filter);

  return (
    <Accordion
      className={classes.root}
      disableGutters={true}
      defaultExpanded={true}
      style={{ boxShadow: "none", borderRadius: "10px" }}>
      <AccordionSummary classes={{ content: classes.content }} onClick={() => setActive(!active)}>
        <b>Level</b>
        <div>
          {(() => {
            if (active) {
              return <span className="material-icons">expand_less</span>;
            } else {
              return <span className="material-icons">expand_more</span>;
            }
          })()}
        </div>
      </AccordionSummary>
      <AccordionDetails>
        {(() => {
          if (!!listLevel) {
            return listLevel.map((item, id) => (
              <FormControlLabel
                className="w-100"
                key={id}
                control={
                  <Checkbox
                    onChange={(e) => handleChange(e)}
                    name={item}
                    value={item}
                    checked={Object.values(filter).includes(item)}
                    sx={{ marginRight: "10px" }}
                  />
                }
                sx={{ textTransform: "capitalize" }}
                label={item}></FormControlLabel>
            ));
          } else {
            return null;
          }
        })()}
      </AccordionDetails>
    </Accordion>
  );
};

export default FilterLevel;
